// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3ewl2","col":"Table_col__3-flN","fulfillmentStatus":"Table_fulfillmentStatus__3aER2","emailCol":"Table_emailCol__ZPW4v"};